import React, { useEffect, useRef, useState } from 'react'
import { postAPI } from '../../app/api'
import { setStore, store } from '../../app/store'
import LoginImg from "../../theme/assets/img/Two-factor-authentication-bro.svg"
import LogoImg from "../../theme/assets/img/wt-logo.png"
import { useParams } from 'react-router-dom'
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export default function SetPassword() {
  const { server_id, user_type, username, reset_token } = useParams();
  const [IsBTNClicked, setIsBTNClicked] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState('');
  // const store_data = JSON.parse(store());
  const [PasswordVisibility, setPasswordVisibility] = useState(false)
  const [ConfirmPasswordVisibility, setConfirmPasswordVisibility] = useState(false)
  const [FormData, setFormData] = useState({
    action: 'ResetPassword'
  })

  const handleChange = e => {
    const { name, value } = e?.target;
    setFormData({ ...FormData, [name]: value })
  }
  
    const resetPassword = async () => {
      try {
        const response = await postAPI("/super_admin/architecture/auth_handle/verify-reset-password", {server_id: server_id, user_type: user_type, username: username, r_token: reset_token, password: FormData?.password});
        // console.log(response)
        if (response?.data?.res == 1) {
          window.location.href = '/Success'
          setIsBTNClicked(false);
          toast.success(`Great Job ! ${response?.data?.msg} .`);
        } else {
          setIsBTNClicked(false);
          toast.error(`Sorry ! ${response?.data?.msg}`);
        }
      } catch (e) {
        setIsBTNClicked(false);
        toast.error('Sorry ! Something Wrong. Please try again.');
        // console.log("Exception Error: ", e?.response?.data?.error)
      }
    }
    function passwordValidator(value) {
      const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$&*~]).{8,16}$/;

      if (!value) {
        return true;
      // } else if (value === "1234abcd" || value === "12345678") {
      //   return null;
      } else if (!pattern.test(value)) {
        return true;
      }

      return false;
    }
    const handleSubmitResetPassword = async () => {
      setErrorMessage('');
      if (IsBTNClicked) {
      } else {
        if(FormData?.password != FormData?.confirm_password) {
          toast.error("Password & confirm password are not same. ")
        } else if (passwordValidator(FormData?.password)) {
          toast.error("Invalid Password.");
          setErrorMessage(`<p>Pin must be between 8-16 characters<br />
          Should contain at least one upper case<br />
          Should contain at least one lower case<br />
          Should contain at least one digit<br />
          Should contain at least one special character</p>`)
        } else {
          resetPassword();
        }
      }
    }

  return (
    <>

      <div class="main-wrapper log-wrap LoginPage">
        <div class="row">
          <div class="col-md-6 login-bg">
            <div class="welcome-login">
              <div class="login-banner"><img class="img-fluid" src={LoginImg} alt="Logo" width="366" height="366" /></div>
              <div class="text-center mentor-course">
                <h2>Welcome to <br />Architecture</h2>
                <p>Set your unique password to access your account securely.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 login-wrap-bg">
            <div class="login-wrapper">
              <div class="loginbox">
                <div class="img-logo"><img class="img-fluid" src={LogoImg} alt="Logo" />
                </div>
                <h1>Setup New Password</h1>
                <p>for <span class="fw-bold">{username}</span></p>
                <form action="#">
                  <div class="form-group">
                    <label class="form-control-label">Password</label>
                    <div class="pass-group" id="passwordInput">
                      <input class="form-control pass-input" onChange={handleChange} type={!PasswordVisibility ? "password" : "text"} name="password" placeholder="Enter your password" />
                      <span class={!PasswordVisibility ? "toggle-password feather-eye" : "toggle-password feather-eye-off"} onClick={() => setPasswordVisibility(!PasswordVisibility)}></span>
                      <span class="pass-checked"><i class="feather-check"></i></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-control-label">Confirm Password</label>
                    <div class="pass-group" id="passwordInputs">
                      <input class="form-control pass-input" onChange={handleChange} type={!ConfirmPasswordVisibility ? "password" : "text"} name="confirm_password" placeholder="Enter your password" />
                      <span class={!ConfirmPasswordVisibility ? "toggle-password feather-eye" : "toggle-password feather-eye-off"} onClick={() => setConfirmPasswordVisibility(!ConfirmPasswordVisibility)}></span>
                      <span class="pass-checked"><i class="feather-check"></i></span>
                    </div>
                  </div>
                  <div className='container-fluid' style={{color: "#cd2312"}} dangerouslySetInnerHTML={{__html: ErrorMessage}}></div>
                  {/* <div class="form-check remember-me">
                    <label class="form-check-label mb-0">
                      <input type="checkbox" class="form-check-input" name="remember" /> 
                      I agree to the&nbsp;
                      <a href="/TermsConditions">Terms of Service</a>&nbsp;and&nbsp; 
                      <a href="/PrivacyPolicy">Privacy Policy.</a>
                    </label>
                  </div> */}
                  <div class="d-grid">
                    <button class="btn btn-primary btn-start" type="button" onClick={handleSubmitResetPassword}>{IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>}Set Password</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
    </>
  )
}
